module.exports = __webpack_public_path__ + "img/fuel.4d0147e5.png";